import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const styles = makeStyles<Theme, { isSticky: boolean }>((theme: Theme) =>
  createStyles({
    containerRoot: {
      height: '100%',
    },
    header: {
      background: theme.palette.primary.light,
      color: theme.palette.text.primary,
      height: (p) => (p.isSticky ? 60 : 260),
      transition: 'height 150ms',

      [theme.breakpoints.up('md')]: {
        height: (p) => (p.isSticky ? 60 : 205),
      },
    },
    toolbar: {
      padding: 0,
      height: '100%',
      alignItems: 'stretch',
      flexDirection: (p) => (p.isSticky ? 'row-reverse' : 'column'),
      justifyContent: 'space-between',
    },

    menuIcon: {
      width: '1.5em',
      height: '1.5em',
    },
    titleRow: {
      alignItems: (p) => (p.isSticky ? 'center' : 'start'),
      height: '100%',
      display: 'flex',
      paddingTop: '1em',
      paddingBottom: (p) => (p.isSticky ? '1em' : '0'),
      position: 'relative',
      order: (p) => (p.isSticky ? 0 : 1),

      [theme.breakpoints.up('md')]: {
        paddingRight: 0,
        maxWidth: '100%',
        justifyContent: 'space-between',
        height: '100px',
        alignItems: (p) => (p.isSticky ? 'center' : 'flex-end'),
        top: (p) => (p.isSticky ? 0 : 'initial'),
        '&&': {
          flexDirection: 'row',
        },
        '& svg': {
          height: 'auto',
        },
      },
    },
    brandSticky: {
      height: '100%',
      width: (p) => (p.isSticky ? '230px' : 'none'),
      maxWidth: '100%',
    },
    brandWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      maxWidth: 580,
      height: '100%',
      '& > svg': {
        height: 'auto',
      },
      [theme.breakpoints.up('sm')]: {
        flexWrap: 'nowrap',
      },
    },
    brand: {
      width: '100%',
      maxWidth: 580,
      marginRight: '3em',
    },
    titleLink: {
      height: '100%',
      color: theme.palette.text.primary,
      textDecoration: 'none',
      alignSelf: (p) => (p.isSticky ? 'center' : 'flex-end'),
    },
    headerBench: {
      display: (p) => (p.isSticky ? 'none' : 'block'),
      marginBottom: '-2px',
    },
    headerTrees: {
      display: (p) => (p.isSticky ? 'none' : 'block'),
      margin: '0 3em',
    },
    headerBenchWithClock: {
      display: (p) => (p.isSticky ? 'none' : 'flex'),
      height: '100px',
      width: '200px',
      alignItems: 'flex-end',
    },
    barIcon: {
      display: (p) => (p.isSticky ? 'none' : 'block'),
    },
    link: {
      transition: 'font-size 200ms',
      color: theme.palette.text.primary,
      fontWeight: 700,
      fontSize: 16,
      marginLeft: theme.spacing(2),
      textDecoration: 'none',
      textTransform: 'uppercase',
      cursor: 'pointer',
      borderBottom: 0,
      fontFamily: ['BundesSans', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      display: 'inline-flex',
      alignItems: 'center',
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    linkDropdown: {
      color: theme.palette.text.primary,
      fontWeight: 700,
      fontSize: 16,
    },
  })
);
